import React from 'react'
import { Trans } from 'react-i18next'

interface Props {
  gameNames: string[]
}

const SelectedGamesSnackbarMessage: React.FC<Props> = ({ gameNames }) => {
  return (
    <div className="SelectedGamesSnackbarMessage">
      <span className="SelectedGamesSnackbarMessage__header">
        <Trans i18nKey="select-game:selected_games" />
      </span>
      <ul className="SelectedGamesSnackbarMessage__list">
        {gameNames.map((gameName, index) => (
          <li key={`${index}-${gameName}`}>{gameName}</li>
        ))}
      </ul>
    </div>
  )
}

export default SelectedGamesSnackbarMessage
